export default __webpack_public_path__ + "static/logo-animated-4a4bde21bcde692d91c61315ebeb3cf7.gif";